module.exports = __webpack_public_path__ + "img/marseilles-fc-logo-icon.03812fb3.png";